export default __webpack_public_path__ + "4ffb3fa5f7540805f5fb229535ca73b6.svg";